import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as commonActions from '../../features/on-boarding/redux/actions';
import ParentContentCard from '../common/ParentContentCard';
import { isProjectReadOnly, themeNames } from '../../common/utils/api_utils';
import Swal from 'sweetalert2';
import TooltipInfo from '../../common/docs/TooltipInfo';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { AppSettingsNav } from '../common/ui/AppSettingsNav';

export class GlobalTheme extends Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    selectedThemeName: null,
    globalThemeFlag: false,
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.loadProjectDetailAppSetting({ projectId, version });
    actions.getGlobalTheme({ version, projectId });
  }

  componentDidUpdate(prevProps) {
    const { onBoarding } = this.props;
    if (prevProps.onBoarding !== onBoarding) {
      const selectedThemeName = this.getSelectedThemeName();
      if (selectedThemeName && selectedThemeName !== this.state.selectedThemeName) {
        this.setState({ selectedThemeName });
      }
    }
    const { globalTheme } = onBoarding;
    const globalThemeFlagForUpdateOrSave =
      globalTheme && globalTheme.some((theme) => theme.customType === 'GLOBAL_THEME');
    if (globalThemeFlagForUpdateOrSave !== this.state.globalThemeFlag) {
      this.setState({ globalThemeFlag: globalThemeFlagForUpdateOrSave });
    }
  }

  handleCardClick = (themeName) => {
    this.setState({ selectedThemeName: themeName });
  };

  handleSave = async () => {
    // const { actions, version, projectId } = this.props;
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    const { selectedThemeName, globalThemeFlag } = this.state;
    await actions.getGlobalTheme({ version, projectId });
    const globalThemeData = {
      urlOrTag: `${process.env.REACT_APP_S3_STATIC_URL}global-theme/bootstrap5/${
        selectedThemeName || 'invalid'
      }/bootstrap.min.css`,
      customType: 'GLOBAL_THEME',
      loadToBuilder: true,
      globalThemeName: selectedThemeName,
    };

    Swal.fire({
      title: selectedThemeName
        ? `Do you want to apply the "${selectedThemeName}" theme?`
        : 'Do you want to remove the theme?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: selectedThemeName
        ? globalThemeFlag
          ? 'Yes, Update it!'
          : 'Yes, Save it!'
        : 'Yes, Remove it!',
      cancelButtonText: 'Cancel',
      confirmButtonColor: selectedThemeName ? '#3085d6' : '#d33',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await actions.addGlobalThemes({ version, projectId, globalThemeData });
          await actions.loadCustomCssCdns({ projectId, version });

          if (!selectedThemeName || selectedThemeName === 'invalid') {
            this.setState({ selectedThemeName: null });
          }
        } catch (error) {
          console.error(error);
        }
      }
    });
  };

  getSelectedThemeName = () => {
    const { onBoarding } = this.props;
    const { globalTheme } = onBoarding;
    if (globalTheme && globalTheme.length > 0) {
      const selectedTheme = globalTheme.find((theme) => theme.customType === 'GLOBAL_THEME');
      return selectedTheme ? selectedTheme.globalThemeName : null;
    }
    return null;
  };
  handleRemove = async () => {
    this.setState({ selectedThemeName: null }, async () => {
      await this.handleSave();
    });
  };

  render() {
    const { selectedThemeName } = this.state;
    const { addGlobalThemesPending, onBoarding, appSetting, match } = this.props;
    const { projectId } = match.params;
    const { globalTheme } = onBoarding;
    const globalThemeFlagForDeleteBtn =
      globalTheme &&
      globalTheme.some(
        (theme) =>
          theme.customType === 'GLOBAL_THEME' && theme.globalThemeName === selectedThemeName,
      );
    const globalThemeFlagForUpdateOrSave =
      globalTheme && globalTheme.some((theme) => theme.customType === 'GLOBAL_THEME');
    const { projectDetail } = appSetting;
    if (!projectDetail) {
      return '';
    }
    const isReadOnly = isProjectReadOnly(projectId);
    return (
      <CommonPageComponent>
        <AppSettingsNav activeTab={'globalTheme'} projectDetail={projectDetail} />
        <div>
          <ParentContentCard title={'Choose Project Look & Feel'} icon={'drapcode-icons'}>
            <div className="container-fluid">
              <h5 style={{ textTransform: 'none' }}>
                It will apply a predefined Ul theme across an application, standardizing the
                appearance of elements like buttons, links, text colors, and fonts for a consistent
                and cohesive design.
              </h5>
              <div className="row show_scrollbar" style={{ height: '45vh', overflow: 'auto' }}>
                {themeNames.map((themeName) => (
                  <div
                    className={`col-md-3 ${
                      selectedThemeName === themeName ? 'border-2 border-success' : ''
                    }`}
                    key={themeName}
                  >
                    <div
                      className={`card`}
                      onClick={() => this.handleCardClick(themeName)}
                      style={{ cursor: 'pointer', borderRadius: '0.25rem', overflow: 'hidden' }}
                    >
                      {selectedThemeName === themeName && (
                        <div
                          className="position-absolute"
                          style={{
                            top: '3px',
                            left: '3px',
                            color: 'green',
                            fontSize: '18px',
                            zIndex: 1,
                            borderRadius: '50%',
                          }}
                        >
                          <i className="fas fa-check-circle"></i>
                        </div>
                      )}
                      <TooltipInfo
                        title={`Preview <b>${themeName || 'theme'}</b> theme`}
                        headerText={``}
                        showHeader={false}
                        showArrow={true}
                        key={themeName || ''}
                      >
                        <button
                          className="btn btn-theme-submit mr-2 btn-xs ml-1 position-absolute mt-2"
                          style={{
                            right: '0px',
                          }}
                          onClick={() =>
                            window.open(`https://bootswatch.com/${themeName}`, '_blank')
                          }
                        >
                          <i className="wb  webconnect-arrow-up-right-circle-fill"></i>
                        </button>
                      </TooltipInfo>
                      <img
                        src={`${process.env.REACT_APP_S3_STATIC_URL}global-theme/bootstrap5/${themeName}/thumbnail.png`}
                        className="card-img-top"
                        alt={`Theme ${themeName}`}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </ParentContentCard>
          <div className="col-12 d-flex justify-content-end">
            <div className="row mr-2">
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 text-right d-flex justify-content-between">
                {globalThemeFlagForDeleteBtn && (
                  <button
                    className="btn  btn-theme-delete btn-md"
                    onClick={isReadOnly ? undefined : this.handleRemove}
                    title={isReadOnly ? 'Read-Only Mode' : 'Remove Theme'}
                    disabled={addGlobalThemesPending || isReadOnly}
                  >
                    <i className="wb webconnect-trash-regular"></i> Remove&nbsp;
                  </button>
                )}
                &nbsp;
                <button
                  className={`btn ${selectedThemeName ? 'btn-theme-submit' : 'btn-default'} btn-md`}
                  onClick={isReadOnly ? undefined : this.handleSave}
                  title={isReadOnly ? 'Read-Only Mode' : 'Save'}
                  disabled={addGlobalThemesPending || !selectedThemeName || isReadOnly}
                >
                  &nbsp;&nbsp;
                  <i className="wb webconnect-save-regular"></i>&nbsp;
                  {globalThemeFlagForUpdateOrSave ? 'Update' : 'Save'}&nbsp;
                </button>
              </div>
            </div>
          </div>
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
    onBoarding: state.onBoarding,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GlobalTheme);
